import { getIcon } from "./get-icon";
import { AtIconProps } from "./at-icon.types";
import { JSX } from "react";
import { CircularProgress } from "@mui/material";

export function AtIcon({
  name,
  className = "",
  size = "medium",
}: AtIconProps): JSX.Element {
  if (name === "loading") {
    return <CircularProgress size={size} className={className} />;
  }

  const icon = getIcon({ name, size, className });
  return icon as JSX.Element;
}
